"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepartmentRegexCsvUploadHints = exports.DepartmentRegexCsvUpload = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var papaparse_1 = __importDefault(require("papaparse"));
var file_1 = require("./file");
var icon_1 = require("../icon");
var translate_1 = require("remota-common/util/translate");
var fat_1 = require("remota-common/util/fat");
var isBlankRow = function (row) { return row.every(function (cell) { return !cell || cell.trim() === ""; }); };
var sanitizeCell = function (value) { var _a; return (_a = value === null || value === void 0 ? void 0 : value.trim()) !== null && _a !== void 0 ? _a : ""; };
var buildDepartmentMap = function (departments) {
    return departments.reduce(function (map, department) {
        map.set(department.code, department);
        return map;
    }, new Map());
};
var isValidRegex = function (pattern) {
    if (!pattern || pattern.trim() === "") {
        return false;
    }
    try {
        new RegExp(pattern);
        return true;
    }
    catch (_a) {
        return false;
    }
};
var DepartmentRegexCsvUpload = function (props) {
    var departments = props.departments, onApply = props.onApply, onLoadingChange = props.onLoadingChange, onErrorsChange = props.onErrorsChange, disabled = props.disabled;
    var _a = __read(react_1.default.useState(false), 2), isProcessing = _a[0], setIsProcessing = _a[1];
    var departmentMap = react_1.default.useMemo(function () { return buildDepartmentMap(departments); }, [departments]);
    var setProcessing = react_1.default.useCallback(function (loading) {
        setIsProcessing(loading);
        onLoadingChange === null || onLoadingChange === void 0 ? void 0 : onLoadingChange(loading);
    }, [onLoadingChange]);
    var reportErrors = react_1.default.useCallback(function (errors) {
        onErrorsChange === null || onErrorsChange === void 0 ? void 0 : onErrorsChange(errors);
    }, [onErrorsChange]);
    var parseRows = react_1.default.useCallback(function (data) {
        var rows = data.slice(1).filter(function (row) { return !isBlankRow(row); });
        var updates = new Map();
        var errors = [];
        rows.forEach(function (row, index) {
            var rowNumber = index + 2;
            if (row.length < 2) {
                errors.push({
                    rowNumber: rowNumber,
                    reason: "\u5217\u6570\u304C\u4E0D\u8DB3\u3057\u3066\u3044\u307E\u3059\u3002\u90E8\u9580\u30B3\u30FC\u30C9\u3068\u6B63\u898F\u8868\u73FE\u306E2\u5217\u304C\u5FC5\u8981\u3067\u3059\u3002",
                });
                return;
            }
            var departmentCode = sanitizeCell(row[0]);
            var regex = sanitizeCell(row[1]);
            if (!departmentCode) {
                errors.push({
                    rowNumber: rowNumber,
                    reason: "\u90E8\u9580\u30B3\u30FC\u30C9\u304C\u7A7A\u3067\u3059\u3002",
                });
                return;
            }
            var matchingDepartment = departmentMap.get(departmentCode);
            if (!matchingDepartment) {
                errors.push({
                    rowNumber: rowNumber,
                    reason: "\u90E8\u9580\u30B3\u30FC\u30C9\u300C".concat(departmentCode, "\u300D\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002"),
                });
                return;
            }
            if (regex && !isValidRegex(regex)) {
                errors.push({
                    rowNumber: rowNumber,
                    reason: "\u90E8\u9580\u30B3\u30FC\u30C9\u300C".concat(departmentCode, "\u300D\u306E\u6B63\u898F\u8868\u73FE\u304C\u7121\u52B9\u3067\u3059\u3002"),
                });
                return;
            }
            updates.set(matchingDepartment.id, regex);
        });
        return { updates: updates, errors: errors };
    }, [departmentMap]);
    var handleCsvText = react_1.default.useCallback(function (text) {
        setProcessing(true);
        reportErrors([]);
        papaparse_1.default.parse(text, {
            skipEmptyLines: true,
            complete: function (result) {
                var _a = parseRows(result.data), updates = _a.updates, errors = _a.errors;
                reportErrors(errors);
                if (updates.size > 0) {
                    onApply(updates);
                }
                setProcessing(false);
            },
            error: function () {
                reportErrors([
                    {
                        rowNumber: 0,
                        reason: "CSVファイルの解析に失敗しました。ファイル形式を確認してください。",
                    },
                ]);
                setProcessing(false);
            },
        });
    }, [onApply, parseRows, reportErrors, setProcessing]);
    return (react_1.default.createElement(file_1.File, { icon: icon_1.upload, label: (0, translate_1.fat)("CSVアップロード"), accept: ".csv,text/csv", onText: handleCsvText, disabled: disabled || isProcessing, shouldResetOnClick: true }));
};
exports.DepartmentRegexCsvUpload = DepartmentRegexCsvUpload;
// Separate component for hints and errors that should be rendered after all buttons
var DepartmentRegexCsvUploadHints = function (_a) {
    var errors = _a.errors, onDismiss = _a.onDismiss;
    var handleDismissErrors = react_1.default.useCallback(function () {
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    }, [onDismiss]);
    var renderErrorCount = react_1.default.useCallback(function (template) { return template.replace("{{count}}", String(errors.length)); }, [errors.length]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Instructions, null,
            react_1.default.createElement("p", null,
                react_1.default.createElement(fat_1.Fat, { id: (0, translate_1.fat)("※ CSV形式: 部門コード, 正規表現") })),
            react_1.default.createElement("p", null,
                react_1.default.createElement(fat_1.Fat, { id: (0, translate_1.fat)("※ ヘッダー行は自動的にスキップされます") }))),
        errors.length === 0 ? null : (react_1.default.createElement(ErrorArea, null,
            react_1.default.createElement(ErrorHeader, null,
                react_1.default.createElement(ErrorTitle, null,
                    react_1.default.createElement(fat_1.Fat, { id: (0, translate_1.fat)("エラー ({{count}}件)"), post: renderErrorCount })),
                react_1.default.createElement(DismissButton, { type: "button", onClick: handleDismissErrors, "aria-label": "\u30A8\u30E9\u30FC\u3092\u9589\u3058\u308B" }, "\u00D7")),
            react_1.default.createElement(ErrorList, null, errors.map(function (error, index) { return (react_1.default.createElement(ErrorItem, { key: index },
                error.rowNumber > 0 ? "\u884C".concat(error.rowNumber, ": ") : "",
                error.reason)); }))))));
};
exports.DepartmentRegexCsvUploadHints = DepartmentRegexCsvUploadHints;
var Instructions = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 13px;\n  line-height: 20px;\n  color: #323c47;\n  margin-bottom: 12px;\n  grid-column: 1 / -1;\n\n  p {\n    margin: 4px 0;\n  }\n"], ["\n  font-size: 13px;\n  line-height: 20px;\n  color: #323c47;\n  margin-bottom: 12px;\n  grid-column: 1 / -1;\n\n  p {\n    margin: 4px 0;\n  }\n"])));
var ErrorArea = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: #fff5f5;\n  border: 1px solid #fc8181;\n  border-radius: 4px;\n  margin-top: 4px;\n  overflow: hidden;\n  grid-column: 1 / -1;\n"], ["\n  background-color: #fff5f5;\n  border: 1px solid #fc8181;\n  border-radius: 4px;\n  margin-top: 4px;\n  overflow: hidden;\n  grid-column: 1 / -1;\n"])));
var ErrorHeader = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  background-color: #fed7d7;\n  border-bottom: 1px solid #fc8181;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  background-color: #fed7d7;\n  border-bottom: 1px solid #fc8181;\n"])));
var ErrorTitle = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-weight: 600;\n  color: #c53030;\n  font-size: 14px;\n"], ["\n  font-weight: 600;\n  color: #c53030;\n  font-size: 14px;\n"])));
var DismissButton = styled_components_1.default.button(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background: none;\n  border: none;\n  font-size: 24px;\n  line-height: 1;\n  color: #c53030;\n  cursor: pointer;\n  padding: 0;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:hover {\n    color: #9b2c2c;\n  }\n"], ["\n  background: none;\n  border: none;\n  font-size: 24px;\n  line-height: 1;\n  color: #c53030;\n  cursor: pointer;\n  padding: 0;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:hover {\n    color: #9b2c2c;\n  }\n"])));
var ErrorList = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  max-height: 200px;\n  overflow-y: auto;\n  padding: 8px 12px;\n"], ["\n  max-height: 200px;\n  overflow-y: auto;\n  padding: 8px 12px;\n"])));
var ErrorItem = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  color: #c53030;\n  font-size: 13px;\n  line-height: 20px;\n  margin: 4px 0;\n  padding: 4px 0;\n\n  &:not(:last-child) {\n    border-bottom: 1px solid #fed7d7;\n  }\n"], ["\n  color: #c53030;\n  font-size: 13px;\n  line-height: 20px;\n  margin: 4px 0;\n  padding: 4px 0;\n\n  &:not(:last-child) {\n    border-bottom: 1px solid #fed7d7;\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
